import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { Event } from '../../../types/Event';
import StatusPill from '../../../uikit/pills/StatusPill';
import { humanizeEventDateTimes } from '../../../utility/dateUtils';
import { UserConfigurableModule } from '../../../types/User';
import DrawerLink from '../drawers/ModuleDrawer/DrawerLink';
import AttendancePill from '../../events/EmployeeTable/AttendancePill';
import { EventsAttendanceResponse } from '../../../services/react-query/events';

const isCompletedAndPast = (status: string | null, startDate: string | null) => {
  if (!startDate || !status) return false;
  const today = new Date();
  const eventDate = new Date(startDate);
  return eventDate < today && status === 'Complete';
};
interface IEventsTimelineTableProps {
  timelineData: Event[];
  attendance?: EventsAttendanceResponse;
}

const EventsTimelineTable = ({ timelineData, attendance }: IEventsTimelineTableProps) => {
  return (
    <TableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>EVENT NAME</TableCell>
            <TableCell>EVENT Date</TableCell>
            <TableCell>STATUS</TableCell>
            {attendance && <TableCell>ATTENDANCE</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {timelineData.map((item: Event) => {
            const completedAndPast = isCompletedAndPast(item.status, item.start_at);
            const rowStyle = completedAndPast ? { backgroundColor: '#ebeced' } : {};

            return (
              <TableRow key={item.uuid} sx={{ ...rowStyle }}>
                <TableCell>
                  <DrawerLink module={UserConfigurableModule.EVENTS} uuid={item.uuid}>
                    {item.display_name}
                  </DrawerLink>
                </TableCell>
                <TableCell>{humanizeEventDateTimes(item)}</TableCell>
                <TableCell>{item.status && <StatusPill status={item.status} text={item.status} />}</TableCell>
                {attendance && <TableCell><AttendancePill status={attendance?.[item.uuid]?.status} /></TableCell>}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EventsTimelineTable;
